<ng-select
  appNgSelectA11y
  [ngSelectA11yId]="effectiveInputId"
  [ngSelectA11yLabelledBy]="labelElementId"
  [appNgSelectA11y]="ariaLabel || ('SEARCH' | translate)"
  [clearable]="true"
  [items]="items"
  [(ngModel)]="selectedItem"
  [compareWith]="compareWith"
  [notFoundText]="'NO_ITEMS_FOUND' | translate"
  [bindLabel]="'label'"
  [bindValue]="'value'"
  [loading]="isLoading"
  [placeholder]="'SEARCH' | translate"
  [appendTo]="'body'"
  [inputAttrs]="{ autocomplete: 'off' }"
  (change)="onChange($event)"
  (open)="onOpen()"
  (search)="onSearch($event)"
  (clear)="onClear()"
  [disabled]="isDisabled"
  >
  @if (showAddNewGroupButton) {
    <ng-template ng-header-tmp>
      <button type="button" class="add-new" (click)="onAddNewGroupClick()">
        <i class="ftmi-plus icon mr-2" aria-hidden="true"></i> {{ 'CREATE_NEW_GROUP' | translate }}
      </button>
    </ng-template>
  }

  <ng-template ng-option-tmp let-item="item" let-index="index">
    {{ item.extraLabels.firstLabel }}
    {{ item.extraLabels.secondLabel }}<br />
    <small>{{ item.extraLabels.thirdLabel ?? item.extraLabels.fourthLabel }}</small>
  </ng-template>
  <!-- WCAG 4.1.3 — same pattern as app-auto-complete (Deque: status-msg-not-auto-announced) -->
  <ng-template ng-notfound-tmp>
    <div class="ng-option disabled" role="alert" aria-atomic="true">{{ 'NO_ITEMS_FOUND' | translate }}</div>
  </ng-template>
</ng-select>
